<template>
    <div
        :class="classes"
        class="cursor-pointer"
        @click="clickHandler"
    >
        <EyeIcon v-if="isOpen" class="h-6 text-[#666666]"/>
        <EyeSlashIcon v-else class="h-6 text-[#666666]"/>
    </div>
</template>

<script setup>
import { EyeIcon, EyeSlashIcon } from "@heroicons/vue/24/solid";

const emit = defineEmits(['trigger-show'])
const props = defineProps({
    classes: {
        type: String,
        default: ''
    },
    isOpen: {
        type: Boolean,
        default: true
    }
})

const clickHandler = () => {
    emit('trigger-show')
}
</script>
